import { ReactNode } from "react";
import { rightContentTargetId } from "./DefaultTemplate.tsx";
import PanelFrame from "../common/panel/PanelFrame.tsx";

interface DefaultTemplatePanelProps {
  children: ReactNode;
  className?: string;
  onRequestClose: () => void;
}

/**
 * Intended to be used by child outside layout.
 * Portals the panel to the appropriate location in the layout and handles
 * close, focus, etc behaviors
 */
export default function DefaultTemplatePanel({
  children,
  className,
  onRequestClose,
}: DefaultTemplatePanelProps) {
  return (
    <PanelFrame
      onRequestClose={onRequestClose}
      targetId={rightContentTargetId}
      classNameInner={className}
    >
      {children}
    </PanelFrame>
  );
}
